<template>
  <div class="rs-text-icon">
    <RsIcon
      weight="far"
      :icon="icon"
    />
    <p>{{ text }}</p>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTextIcon',

  props: {
    icon: String,
    text: String,
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.rs-text-icon {
  position: relative;
  display: flex;
  .rs-icon {
    margin-right: 0.25rem;
    color: $secondary-color;
    vertical-align: text-top;
    font-size: 20px;
  }
}
</style>
